module.exports = __webpack_public_path__ + "static/media/Mueller_logo.2dbcb44f.svg";